import React from "react";
import PropTypes from "prop-types";
import { Table } from "../../../components/ui/Table";
import { FormatInt } from "../../../utils/FormatData";
import { useRCSByPartner } from "../hooks/useRCSByPartner";
const RCSPartners = () => {
  const { data, isPending: loading, isFetching } = useRCSByPartner();

  const columns = [
    {
      Header: "Partner",
      accessor: "vc_partner",
    },
    {
      Header: "Enviados",
      accessor: "i_send",
      Cell: (rowData) => {
        let value = rowData.row.original.i_send;
        return FormatInt(value);
      },
    },
    {
      Header: "Respuestas",
      accessor: "i_responses",
      Cell: (rowData) => {
        let value = rowData.row.original.i_responses;
        return FormatInt(value);
      },
    },
    {
      Header: "Por procesar",
      accessor: "i_pending",
      Cell: (rowData) => {
        let value = rowData.row.original.i_pending;
        return FormatInt(value);
      },
    },
    {
      Header: "Invalidos",
      accesor: "i_invalid",
      Cell: (rowData) => {
        let value = rowData.row.original.i_invalids;
        return FormatInt(value);
      },
    },
  ];

  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <Table
        title="Mensajes por procesar API"
        data={data}
        columns={columns}
        loading={loading || isFetching}
        config={{}}
        rowRule={(row) => {
          const raw = Number(row.original.i_pending);
          const abs = Math.abs(raw);
          if (abs > 0) {
            return "bg-yellow-100";
          }
        }}
      />
    </div>
  );
};

RCSPartners.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
};

export default RCSPartners;
